import {useCallback, useState} from 'react'

export function useAlertTrackingErrors() {
  const [errors, setErrors] = useState<Array<{title: string; body: string}>>([])

  const resetErrors = useCallback(() => setErrors([]), [])

  const setFromNewErrors = useCallback((newErrors: Error[]) => {
    setErrors(currentErrors => [
      ...currentErrors,
      ...newErrors.map(error => ({
        title: 'Unexpected error',
        body: `An unexpected error occurred. ${error.message}`,
      })),
    ])
  }, [])

  return {errors, resetErrors, setErrors: setFromNewErrors}
}
